export default [
  {
    path: '/my/interview/:id',
    name: 'individual.interview',
    component: () => import('@/views/Interview')
  },
  {
    path: '/my',
    name: 'individual.home',
    component: () => import('@/views/NewHome'),
    redirect: { name: 'individual.home.user' },
    children: [
      {
        path: '/',
        name: 'individual.home.user',
        component: () => import('@/components/home/index/homepage-individual')
      },
      {
        path: '/lists',
        name: 'individual.home.user.lists',
        component: () => import('@/components/home/HomepageUserLists'),
        children: [
          {
            path: 'manage/:listId?',
            name: 'individual.home.user.lists.lists.manage',
            component: () => import('@/components/lists/ModalManageList'),
            meta: {
              backRouteName: 'individual.home.user.lists'
            }
          },
          {
            path: 'details/:listId',
            name: 'individual.home.user.lists.lists.details',
            component: () => import('@/components/lists/ModalListDetails'),
            meta: {
              backRouteName: 'individual.home.user.lists'
            },
            children: [
              {
                path: 'manage/:listId?',
                name: 'individual.home.user.lists.lists.details.lists.manage',
                component: () => import('@/components/lists/ModalManageList'),
                meta: {
                  backRouteName: 'individual.home.user.lists'
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/my/applications',
    name: 'individual.candidature.index',
    component: () => import('@/views/Candidature'),
    redirect: { name: 'individual.candidature.under.analysis' },
    children: [
      {
        path: '/my/applications/under-analysis',
        name: 'individual.candidature.under.analysis',
        component: () => import('@/views/Candidature/UnderAnalysisCandidatures')
      },
      {
        path: '/my/applications/unfinished',
        name: 'individual.candidature.unfinished',
        component: () => import('@/views/Candidature/NotCompletedCandidatures')
      },
      {
        path: '/my/applications/saved',
        name: 'individual.candidature.saved',
        component: () => import('@/views/Candidature/SavedCandidatures')
      },
      {
        path: '/my/applications/closed',
        name: 'individual.candidature.closed',
        component: () => import('@/views/Candidature/ClosedCandidatures')
      }]
  },
  {
    path: '/my/career',
    name: 'individual.home.user.career',
    component: () => import('@/views/EmptyRouterView')
  },
  {
    path: '/my/discovery/position/:positionId',
    name: 'individual.position.details',
    component: () => import('@/views/PositionView'),
    meta: {
      backRouteName: 'individual.discovery.index'
    }
  },
  {
    path: '/my/discovery/course/:courseId',
    name: 'individual.course.details',
    component: () => import('@/views/CourseView'),
    meta: {
      backRouteName: 'individual.discovery.index'
    }
  },
  {
    name: 'individual.discovery.index',
    path: '/my/discovery',
    component: () => import('@/views/IndividualDiscovery'),
    redirect: { name: 'individual.discovery.index.search', query: { type: 'positions' } },
    children: [
      {
        path: 'list/details/:listId',
        name: 'individual.discovery.index.default.list.details',
        component: () => import('@/components/lists/ModalListDetails'),
        meta: {
          backRouteName: 'individual.discovery.index'
        }
      },
      {
        path: 'search',
        name: 'individual.discovery.index.search',
        component: () => import('@/views/Discovery/DiscoveryFilter'),
        meta: {
          backRouteName: 'individual.discovery.index'
        }
      }
    ]
  }
]
